import {useEffect} from "react";
import Section from "../components/Section";
import PageBackground from "../components/PageBackground";
import pageBackground from '../assets/backgrounds/platform_apps.jpg';
import {BottomNavigator} from "../components/Navbar";
import {useTranslation} from "react-i18next";
import ScrollReveal from "../components/ScrollReveal";

const appScreens = [
    require('../assets/screenshots/screen-1.webp'),
    require('../assets/screenshots/screen-2.webp'),
    require('../assets/screenshots/screen-3.webp'),
    require('../assets/screenshots/screen-4.webp'),
    require('../assets/screenshots/screen-5.webp')
];

const AppsPage = ({embedded = false}) => {
    const {t} = useTranslation();

    useEffect(() => {
        if (embedded) {
            return undefined;
        }

        document.body.style.backgroundColor = '#050507';

        return () => {
            document.body.style.backgroundColor = null;
        };
    }, [embedded]);

    return (
        <div className={'Page AppsPage'}>
            <Section className={'TopSection'}>
                <PageBackground src={pageBackground}/>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h1'} threshold={0.12} variant={'up'}>
                        {t('apps.title')}
                    </ScrollReveal>

                    <ScrollReveal as={'p'}
                                  className={'AppsPage__note'}
                                  threshold={0.12}
                                  delay={70}
                                  variant={'right'}
                    >
                        {t('apps.showcase_note')}
                    </ScrollReveal>

                    <div className={'Sreenshots'}>
                        {
                            appScreens.map((image, index) => (
                                <ScrollReveal key={index}
                                              as={'img'}
                                              src={image}
                                              threshold={0.12}
                                              delay={120 + index * 70}
                                              variant={['left', 'up', 'right', 'down', 'scale'][index]}
                                />
                            ))
                        }
                    </div>
                </div>
            </Section>

            {
                !embedded &&
                <BottomNavigator
                    prev={{
                        to: '/components',
                        title: t('navbar.components')
                    }}
                    next={{
                        to: '/roadmap',
                        title: t('navbar.roadmap')
                    }}/>
            }
        </div>
    )
};

export default AppsPage;
